import { TENANTS } from "../../../constants"
import cetelemLogo from "./../../../asset/img/cetelem/logo-cetelem.png"
import mediamarktNllogo from "./../../../asset/img/mediamarkt_nl/evollis_logo.png"
import retailItalylogo from "./../../../asset/img/retail_it/logo-retail-it.png"
import retailPtlogo from "./../../../asset/img/retail_pt/evollis_logo.png"
import BplsLogo from "./BplsLogo"
import RetailLogo from "./RetailLogo"
import RetailLogoWrapper from "./RetailLogoWrapper"
import React from "react"

const DynamicLogo = ({ tenant, brandLogo }) => {
  switch (tenant) {
    case TENANTS.MORTAR:
      return (
        <RetailLogoWrapper>
          <RetailLogo sourceImg={cetelemLogo} alt={"PDI Retail Cetelem"} />
        </RetailLogoWrapper>
      )
    case TENANTS.BUT:
      return (
        <RetailLogoWrapper>
          <RetailLogo sourceImg={cetelemLogo} alt={"PDI Retail BUT"} />
        </RetailLogoWrapper>
      )
    case TENANTS.CONFORAMA_RETAIL:
      return (
        <RetailLogoWrapper>
          <RetailLogo sourceImg={cetelemLogo} alt={"PDI Retail CONFORAMA RETAIL"} />
        </RetailLogoWrapper>
      )
    case TENANTS.RETAIL_IT:
      return (
        <RetailLogoWrapper>
          <RetailLogo sourceImg={retailItalylogo} alt={"PDI Retail Personal-Renting"} />
        </RetailLogoWrapper>
      )
    case TENANTS.RETAIL_FNAC_PT:
      return (
        <RetailLogoWrapper>
          <RetailLogo sourceImg={retailPtlogo} alt={"PDI Retail Fnac PT"} />
        </RetailLogoWrapper>
      )
    case TENANTS.MEDIAMARKT_NL:
    case TENANTS.MEDIAMARKT_BE:
      return (
        <RetailLogoWrapper>
          <RetailLogo sourceImg={mediamarktNllogo} alt={"PDI Retail MediaMarkt"} />
        </RetailLogoWrapper>
      )
    case TENANTS.BPLS:
      return <BplsLogo />
    default:
      return <img src={brandLogo} alt="brand logo" />
  }
}

export default DynamicLogo
